import { motion } from 'motion/react';
import { X } from 'lucide-react';

interface YutStickProps {
  isFlat: boolean;
  index: number;
  isAnimating: boolean;
}

export function YutStick({ isFlat, index, isAnimating }: YutStickProps) {
  return (
    <motion.div
      className="relative"
      initial={{ rotateY: 0 }}
      animate={
        isAnimating
          ? {
              rotateY: [0, 360, 720, 1080],
              y: [-20, -60, -40, 0],
            }
          : { rotateY: isFlat ? 0 : 180, y: 0 }
      }
      transition={{
        duration: isAnimating ? 1.2 : 0.4,
        delay: index * 0.1,
        ease: "easeOut",
      }}
      style={{ perspective: 1000 }}
    >
      <div className="w-10 h-32 relative">
        {/* Flat side (face up) - Brighter with X marks */}
        <div
          className={`absolute inset-0 rounded-lg transition-opacity flex flex-col items-center justify-around py-2 ${
            isFlat ? 'opacity-100' : 'opacity-0'
          }`}
          style={{
            background: 'linear-gradient(135deg, #E8A87C 0%, #D2916F 50%, #C4845D 100%)',
            boxShadow: '0 4px 8px rgba(0,0,0,0.15), inset 0 2px 4px rgba(255,255,255,0.4)',
          }}
        >
          {/* Three X marks on flat side */}
          <X size={14} className="text-amber-900/60" strokeWidth={3} />
          <X size={14} className="text-amber-900/60" strokeWidth={3} />
          <X size={14} className="text-amber-900/60" strokeWidth={3} />
        </div>
        
        {/* Rounded side (face down) - Darker with no pattern */}
        <div
          className={`absolute inset-0 rounded-lg transition-opacity ${
            !isFlat ? 'opacity-100' : 'opacity-0'
          }`}
          style={{
            background: 'linear-gradient(135deg, #8B6F47 0%, #6B5637 50%, #5C4A2E 100%)',
            boxShadow: '0 4px 8px rgba(0,0,0,0.25), inset -2px 0 4px rgba(0,0,0,0.4)',
          }}
        />
      </div>
    </motion.div>
  );
}